import React from 'react';
import { IconButton, Dropdown, Menu } from 'ui-kit';
import { MoreVertical as MoreVerticalIcon } from 'react-feather';
import { ProductCategory } from 'api/types/product';
import { isLocalProduct } from 'utils/product';

interface Props {
  onEdit?: () => void;
  onDelete?: () => void;
  onShare?: () => void;
  onPropagate?: () => void;
  onMassDelete?: () => void;
  category: ProductCategory;
  isLink: boolean;
  productGroup: number;
  isWalkthroughExample?: boolean;
}

const ProductCardAdminMenu = ({
  onEdit,
  onDelete,
  onShare,
  onPropagate,
  onMassDelete,
  category,
  isLink,
  productGroup,
  isWalkthroughExample,
}: Props) => {
  const actionClick = (callback) => (e) => {
    e.domEvent.stopPropagation();
    callback();
  };

  if (isLocalProduct(category) && isLink) {
    return null;
  }

  return (
    <Dropdown
      className="ProductCardAdmin-menu"
      placement="bottomRight"
      trigger={['click']}
      overlay={
        <Menu>
          {!isLocalProduct(category) && <Menu.Item onClick={actionClick(onEdit)}>Edit</Menu.Item>}
          {!isLocalProduct(category) && !productGroup && (
            <Menu.Item onClick={actionClick(onPropagate)}>Add Tile to All Stores</Menu.Item>
          )}
          {!isLink && <Menu.Item onClick={actionClick(onShare)}>Share Product Link</Menu.Item>}
          {!isLocalProduct(category) && (
            <Menu.Item onClick={actionClick(onDelete)}>Delete</Menu.Item>
          )}
          {!isLocalProduct(category) && productGroup && (
            <Menu.Item onClick={actionClick(onMassDelete)}>Delete Tile from All Stores</Menu.Item>
          )}
        </Menu>
      }
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <IconButton
        color="primary"
        variant="text"
        data-walkthrough={isWalkthroughExample ? 'product-menu' : undefined}
      >
        <MoreVerticalIcon />
      </IconButton>
    </Dropdown>
  );
};

export default ProductCardAdminMenu;
